import React from 'react'
import {
  TextField,
  ArrayField,
  SingleFieldList,
  FunctionField,
  ShowController,
  ShowView,
  TabbedShowLayout,
  Tab,
  List,
  Datagrid,
  ReferenceField,
} from 'react-admin'
import { Box, Typography } from '@material-ui/core'
import { isRoleSportsmanOrCoach, isRoleOrganizer } from '../utils'
import {
  formatStatus,
  formatRole,
  formatGender,
  formatSportKind,
  formatDate,
} from '../utils'
import { EMPTY_SPACE } from '../../utils/constants'
import { OrganizerTournamentList } from './fields'

const UserTitle = ({ record }) => {
  return <span>{record.fullName || ''}</span>
}

const ShowUser = (props) => {
  const currentUserId = props.id
  return (
    <ShowController {...props}>
      {(controllerProps) => (
        <ShowView {...props} {...controllerProps} title={<UserTitle />}>
          <TabbedShowLayout>
            <Tab label='Информация' title='Информация'>
              <TextField source='fullName' label='ФИО' />
              <FunctionField
                label='Роль'
                render={(record) =>
                  (record.roles || [])
                    .map((role) => formatRole(role))
                    .filter(Boolean)
                    .join(', ')
                }
              />
              <TextField source='email' label='Email' />
              <TextField source='phone' label='Телефон' />
              <ReferenceField source='city.id' reference='cities' label='Город'>
                <TextField source='name' />
              </ReferenceField>
              <FunctionField
                source='dateOfBirth'
                label='Дата Рождения'
                render={() =>
                  formatDate(controllerProps.record.dateOfBirth, 'DD/MM/YYYY')
                }
              />
              <FunctionField
                label='Пол'
                render={(record) => formatGender(record.gender)}
              />
              <TextField source='email' label='E-mail' />
              <TextField source='phone' label='Телефон' />
              <ReferenceField source='city.id' reference='cities' label='Город'>
                <TextField source='name' />
              </ReferenceField>
              <FunctionField
                label='Вид спорта'
                render={(record) => formatSportKind(record.sportKind)}
              />
              {isRoleSportsmanOrCoach(controllerProps.record?.roles) && [
                <TextField
                  source='name'
                  label='Статистика по медалям'
                  emptyText='Не указано'
                />,
                controllerProps.record?.fightBelts.length && (
                  <ArrayField source='fightBelts' label='Пояс' fieldKey='id'>
                    <SingleFieldList linkType={false}>
                      <FunctionField
                        render={(belt) => belt.belt + ',' + EMPTY_SPACE}
                      />
                    </SingleFieldList>
                  </ArrayField>
                ),
                controllerProps.record?.fightBelts.length && (
                  <ArrayField source='participatedClubs' label='Клуб'>
                    <Datagrid>
                      <FunctionField render={(club) => club.name} />
                      <FunctionField
                        render={(club) => {
                          if (club.isOwner) return 'Владелец'
                        }}
                      />
                    </Datagrid>
                  </ArrayField>
                ),
              ]}
            </Tab>
            {isRoleSportsmanOrCoach(controllerProps.record?.roles) && (
              <Tab label='Турниры'>
                <FunctionField
                  addLabel={false}
                  fullWidth
                  render={() => (
                    <List
                      bulkActionButtons={false}
                      actions={false}
                      title=' - Турниры'
                      exporter={false}
                      filter={{ user: currentUserId }}
                      basePath='/user_tournaments'
                      resource='user_tournaments'
                      empty={
                        <Box textAlign='center' m={1}>
                          <Typography variant='h4' paragraph>
                            Ничего не найдено
                          </Typography>
                        </Box>
                      }
                    >
                      <Datagrid>
                        <TextField label='Турнир' source='tournament.name' />
                      </Datagrid>
                    </List>
                  )}
                />
              </Tab>
            )}
            {isRoleSportsmanOrCoach(controllerProps.record?.roles) && (
              <Tab label='Регистрации'>
                <Typography variant='h4' paragraph>
                  Регистрации
                </Typography>
                <FunctionField
                  addLabel={false}
                  fullWidth
                  render={() => (
                    <List
                      bulkActionButtons={false}
                      actions={false}
                      exporter={false}
                      filter={{ user: currentUserId, deleted: false }}
                      basePath='/participation_requests'
                      title=' - Регистрации'
                      resource='participation_requests'
                      empty={
                        <Box textAlign='center' m={1}>
                          <Typography variant='h4' paragraph>
                            Ничего не найдено
                          </Typography>
                        </Box>
                      }
                    >
                      <Datagrid rowClick={(id) => `/tournaments/${id}/show`}>
                        <TextField
                          label='Турнир'
                          source='category.tournament.name'
                        />
                      </Datagrid>
                    </List>
                  )}
                />
                <Typography variant='h4' paragraph>
                  Клубы
                </Typography>
                <FunctionField
                  addLabel={false}
                  fullWidth
                  render={() => (
                    <List
                      bulkActionButtons={false}
                      actions={false}
                      exporter={false}
                      filter={{ user: currentUserId, deleted: false }}
                      basePath='/membership_requests'
                      resource='membership_requests'
                      title=' '
                      empty={
                        <Box textAlign='center' m={1}>
                          <Typography variant='h4' paragraph>
                            Ничего не найдено
                          </Typography>
                        </Box>
                      }
                    >
                      <Datagrid rowClick={(id) => `/clubs/${id}/show`}>
                        <TextField label='Турнир' source='club.name' />
                        <FunctionField
                          label='Статус'
                          render={(record) => formatStatus(record.status)}
                        />
                      </Datagrid>
                    </List>
                  )}
                />
              </Tab>
            )}
            {isRoleOrganizer(controllerProps.record?.roles) && [
              <Tab label='Турниры'>
                <OrganizerTournamentList id={currentUserId} />
              </Tab>,
              <Tab label='Реквизиты'>
                <div>Информация об организации</div>
                <TextField
                  source='organizationDirectorFullName'
                  label='ФИО директора'
                  emptyText='Не указано'
                />
                <TextField
                  source='organizationName'
                  label='Названии организации'
                  emptyText='Не указано'
                />
                <TextField
                  source='organizationAddress'
                  label='Адрес'
                  emptyText='Не указано'
                />
                <TextField
                  source='organizationEmail'
                  label='E-mail'
                  emptyText='Не указано'
                />
                <TextField
                  source='organizationCity.name'
                  label='Город'
                  emptyText='Не указано'
                />
                <TextField
                  source='organizationPostalCode'
                  label='Индекс'
                  emptyText='Не указано'
                />
                <TextField
                  source='organizationPhone'
                  label='Телефон организации'
                />
              </Tab>,
            ]}
          </TabbedShowLayout>
        </ShowView>
      )}
    </ShowController>
  )
}

export default ShowUser
